import { render, staticRenderFns } from "./WDS2UnitEditor.vue?vue&type=template&id=8f1d2cca&scoped=true"
import script from "./WDS2UnitEditor.vue?vue&type=script&lang=js"
export * from "./WDS2UnitEditor.vue?vue&type=script&lang=js"
import style0 from "./WDS2UnitEditor.vue?vue&type=style&index=0&id=8f1d2cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1d2cca",
  null
  
)

export default component.exports